import PropTypes from 'prop-types'

import ConfirmationDialog from '../../ConfirmationDialog/index'

const MatchingGuestDialog = ({
  guestFirstName,
  guestLastName,
  roomNumber,
  handleSubmit,
  handleCancel
}) => (
  <ConfirmationDialog
    title="Is this who you are looking for?"
    positiveMessage="Yes"
    negativeMessage="No"
    onConfirm={handleSubmit}
    onClose={handleCancel}
    hasFixedTopMargin={true}
    onPressEnter={handleSubmit}
  >
    <div>
      {guestFirstName} {guestLastName} - Room {roomNumber}
    </div>
  </ConfirmationDialog>
)

MatchingGuestDialog.prototypes = {
  clientFullName: PropTypes.string.isRequired,
  roomNumber: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired
}

export default MatchingGuestDialog
